import {frameworkAutoplay} from "../../../core/components/autoplay/configuration/autoplayconfiguration";
import {autoplayAssetConfig} from "../../../data/autoplay";
import {mobViewPanelAssetConfig} from "../../../data/mobViewPanel";

frameworkAutoplay.data = {
    "AUTOPLAY_CONTAINER_X": 380,
    "AUTOPLAY_CONTAINER_Y": 50,
    "autoplayBaseImage": autoplayAssetConfig["autoplayBaseImage"],
    "clickedNumberButton": autoplayAssetConfig["clickedNumberButton"],
    "unclickedNumberButton": autoplayAssetConfig["unclickedNumberButton"],
    "toggleButtonOnImage": autoplayAssetConfig["toggleButtonOnImage"],
    "toggleButtonOffImage": autoplayAssetConfig["toggleButtonOffImage"],
    "mobPanelButtonsImage": mobViewPanelAssetConfig["mobPanelButtonsImage"],
    "meterImage": autoplayAssetConfig["meterImage"],
    "COMPONENTS": [
        {
            "id": "AutoplayGenericUIContainer",
            "name": "AutoplayGenericUIContainer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            child: [
                {
                    "id": "AutoplayGenericUIComponent",
                    "name": "AutoplayGenericUI",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    child: []
                }
            ]
        },
    ],
};